export default __webpack_public_path__ + "static/media/james.ebf03b87.jpg";